import { Typography } from "@mui/material";
import { OwcButton } from "@one/react";
import { react18WorkaroundProps } from "../../utils/constants/react18WorkaroundProps";
import styled from "styled-components";

const InfoStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px;
`;

export const InfoWithCallback = ({
  title = "Cannot fetch data",
  buttonLabel = "Retry",
  callback,
  containerProps = null,
  titleProps = null,
  buttonProps = null
}) => {
  return (
    <InfoStyled data-testid="InfoWithCallback-container" {...containerProps}>
      <Typography data-testid="InfoWithCallback-title" variant="h6" gutterBottom {...titleProps}>
        {title}
      </Typography>
      <OwcButton
        {...react18WorkaroundProps}
        data-testid="InfoWithCallback-button"
        variant="primary"
        onClick={() => typeof callback === "function" && callback()}
        {...buttonProps}
      >
        {buttonLabel}
      </OwcButton>
    </InfoStyled>
  );
};
